import { MOTORIZACION } from '../constants/carline-constants';
import { FaContent } from '../types/form-types';

class ExternalContentManager {
	private static instance: ExternalContentManager;
	private fc: FaContent | null = null;
	private qp = new URLSearchParams(window.location.search);
	private uri = window.location.href.split('/');

	private constructor() {}

	static getInstance(): ExternalContentManager {
		if (!ExternalContentManager.instance) {
			ExternalContentManager.instance = new ExternalContentManager();
		}
		return ExternalContentManager.instance;
	}

	setFaContent(faContent?: FaContent): void {
		this.fc = faContent as FaContent;
	}

	get faContent(): FaContent | null {
		return (this.fc as FaContent) || null;
	}

	get dpsFields(): FaContent['dpsFields'] | null {
		if (!this.fc?.dpsFields) return null;

		return this.fc.dpsFields.map((field) => ({
			field: field.field,
			value: field.value,
		}));
	}

	get isLayerForm(): boolean {
		return (
			this.fc?.isLayer == true ||
			this.fc?.isLayer == 'true' ||
			this.fc?.params?.isLayer == true ||
			this.fc?.params?.isLayer == 'true' ||
			false
		);
	}

	get isInvertedThemeForm(): boolean {
		return this.fc?.theme == 'inverted' || this.fc?.params?.theme == 'inverted' || false;
	}

	get formName(): string {
		return (
			this.fc?.formName ||
			this.fc?.params?.formName ||
			this.qp.get('formName') ||
			this.fc?.formNameAdhoc ||
			this.fc?.params?.formNameAdhoc ||
			''
		);
	}

	get forms(): any[] | null {
		return this.fc?.forms ?? null;
	}

	get featureApp(): string | null {
		return (
			this.fc?.featureApp ||
			this.fc?.params?.featureApp ||
			this.qp.get('featureApp') ||
			this.fc?.featureAppAdhoc ||
			this.fc?.params?.featureAppAdhoc ||
			null
		);
	}

	get carlines(): string[] | null {
		const paramCarlines = this.splitComma(
			[
				...this.asArray(this.fc?.params?.carlines),
				...this.asArray(this.fc?.params?.carline),
				...this.asArray(this.fc?.carlines),
				...this.qp.getAll('carlines'),
				...this.qp.getAll('carline'),
				...this.asArray(this.uriCarline),
			].filter(Boolean),
		);

		// Eliminar duplicados
		const carlines = Array.from(new Set(paramCarlines));

		return carlines.length > 0 ? carlines : null;
	}

	get salesgroups(): string[] | null {
		const paramSalesgroups = this.splitComma(
			[
				...this.asArray(this.fc?.params?.salesgroups),
				...this.asArray(this.fc?.params?.salesgroup),
				...this.asArray(this.fc?.salesgroups),
				...this.qp.getAll('salesgroups'),
				...this.qp.getAll('salesgroup'),
				...this.asArray(this.uriSalesgroup),
			].filter(Boolean),
		);

		// Eliminar duplicados
		const salesgroups = Array.from(new Set(paramSalesgroups));

		return salesgroups.length > 0 ? salesgroups : null;
	}

	get motorizacion(): MOTORIZACION | null {
		const value = this.fc?.motorizacion || this.fc?.params?.motorizacion || this.qp.get('motorizacion');

		return Object.values(MOTORIZACION).find((motorizacion) => motorizacion === value) ?? null;
	}

	// Devuelve carline + transformacion
	get transformaciones(): string[] | null {
		const paramTransformaciones = this.splitComma(
			[
				...this.asArray(this.fc?.params?.transformaciones),
				...this.asArray(this.fc?.params?.transformacion),
				...this.asArray(this.fc?.transformaciones),
				...this.qp.getAll('transformaciones'),
				...this.qp.getAll('transformacion'),
			].filter(Boolean),
		);

		// Eliminar duplicados
		const transformaciones = Array.from(new Set(paramTransformaciones));

		return transformaciones.length > 0 ? transformaciones : null;
	}

	get marketingCode(): string | null {
		return (
			this.fc?.marketingCode ||
			this.fc?.params?.marketingCode ||
			this.qp.get('marketingCode') ||
			this.token?.marketingCode ||
			null
		);
	}

	get ofertaId(): string | null {
		return this.fc?.ofertaId || this.fc?.params?.ofertaId || this.qp.get('ofertaId') || this.token?.ofertaId || null;
	}

	// Devuelve el KVPS de dealerId
	get dealerId(): string | undefined {
		return (
			this.fc?.dealerId || this.fc?.params?.dealerId || this.qp.get('dealerId') || this.token?.dealerId || undefined
		);
	}

	get token(): any | null {
		try {
			const token = this.qp.get('token')?.replace(/=+$/, '');
			const decoded = token ? atob(token) : null;
			return decoded ? JSON.parse(decoded) : null;
		} catch (err) {
			console.error('Error decoding token:', err);
			return null;
		}
	}

	// Segmentos del path tras el .html, ejemplo: mas-informacion.html/polo/polo-match.app
	private get uriPathParts(): string[] {
		const htmlIndex = this.uri.findIndex((p) => p.includes('.html'));
		if (htmlIndex === -1) return [];
		return this.uri
			.slice(htmlIndex + 1)
			.map((p) => p.split(/[?#]/)[0].replace(/\.app$/, ''))
			.filter(Boolean);
	}

	private get uriCarline(): string | null {
		return this.uriPathParts[0] ?? null;
	}

	private get uriSalesgroup(): string | null {
		const parts = this.uriPathParts;
		return parts.length >= 2 ? parts[1] : null;
	}

	private splitComma(values: any[]): string[] {
		return values.reduce((acc: string[], v: any) => {
			const parts = String(v).split(',');
			for (const p of parts) {
				const trimmed = p.trim();
				if (trimmed) acc.push(trimmed);
			}
			return acc;
		}, []);
	}

	private asArray(v: unknown): string[] {
		if (!v) return [];
		return Array.isArray(v) ? v.map(String) : [String(v)];
	}
}

export const externalContentManager = ExternalContentManager.getInstance();
